var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFileTypeZip(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 30,
    viewBox: "0 0 24 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 30H21.5C22.8807 30 24 28.8807 24 27.5V9.62018C24 8.94933 23.7304 8.30663 23.2518 7.83656L16.0021 0.71638C15.5347 0.257247 14.9056 0 14.2504 0H2.5C1.11929 0 0 1.11929 0 2.5V27.5C0 28.8807 1.11929 30 2.5 30Z",
    fill: "#003393"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.75 19.05C9.75 17.8074 10.7574 16.8 12 16.8C13.2426 16.8 14.25 17.8074 14.25 19.05V23.55C14.25 24.7927 13.2426 25.8 12 25.8C10.7574 25.8 9.75 24.7927 9.75 23.55V19.05ZM12.9 19.05C12.9 19.547 12.497 19.95 12 19.95C11.5029 19.95 11.1 19.547 11.1 19.05C11.1 18.5529 11.5029 18.15 12 18.15C12.497 18.15 12.9 18.5529 12.9 19.05ZM12 21.3C11.5029 21.3 11.1 21.703 11.1 22.2V23.55C11.1 24.0471 11.5029 24.45 12 24.45C12.497 24.45 12.9 24.0471 12.9 23.55V22.2C12.9 21.703 12.497 21.3 12 21.3Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12 2.4C12 2.89706 11.597 3.3 11.1 3.3C10.6029 3.3 10.2 2.89706 10.2 2.4C10.2 1.90294 10.6029 1.5 11.1 1.5C11.597 1.5 12 1.90294 12 2.4Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8 4.20002C13.8 4.69707 13.397 5.10002 12.9 5.10002C12.4029 5.10002 12 4.69707 12 4.20002C12 3.70296 12.4029 3.30002 12.9 3.30002C13.397 3.30002 13.8 3.70296 13.8 4.20002Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8 7.79999C13.8 8.29705 13.397 8.69999 12.9 8.69999C12.4029 8.69999 12 8.29705 12 7.79999C12 7.30294 12.4029 6.89999 12.9 6.89999C13.397 6.89999 13.8 7.30294 13.8 7.79999Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8 11.4C13.8 11.8971 13.397 12.3 12.9 12.3C12.4029 12.3 12 11.8971 12 11.4C12 10.9029 12.4029 10.5 12.9 10.5C13.397 10.5 13.8 10.9029 13.8 11.4Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M12 6.00001C12 6.49706 11.597 6.90001 11.1 6.90001C10.6029 6.90001 10.2 6.49706 10.2 6.00001C10.2 5.50295 10.6029 5.10001 11.1 5.10001C11.597 5.10001 12 5.50295 12 6.00001Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M12 9.59998C12 10.097 11.597 10.5 11.1 10.5C10.6029 10.5 10.2 10.097 10.2 9.59998C10.2 9.10293 10.6029 8.69998 11.1 8.69998C11.597 8.69998 12 9.10293 12 9.59998Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M12 13.2C12 13.6971 11.597 14.1 11.1 14.1C10.6029 14.1 10.2 13.6971 10.2 13.2C10.2 12.703 10.6029 12.3 11.1 12.3C11.597 12.3 12 12.703 12 13.2Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8 15C13.8 15.4971 13.397 15.9 12.9 15.9C12.4029 15.9 12 15.4971 12 15C12 14.5029 12.4029 14.1 12.9 14.1C13.397 14.1 13.8 14.5029 13.8 15Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileTypeZip);
export default __webpack_public_path__ + "static/media/file-type-zip.c316c7ad141d762e648f4e12d2a66656.svg";
export { ForwardRef as ReactComponent };